import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { routes } from "@config/utilities/utils.constant";
import { Link } from 'react-router-dom';

function useIsClient() {
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => { 
    setIsClient(true);
  }, []);
  
  return isClient;
} 

const RippleButton = () => {
      const isClient = useIsClient();
   const buttonRef = useRef(null);
  const [ripples, setRipples] = useState([]);

  const rippleEffect = (event) => {
    const btn = buttonRef.current;
    if (!isClient || !btn) return;

    const rect = btn.getBoundingClientRect();
    const diameter = Math.max(btn.clientWidth, btn.clientHeight);
    const radius = diameter / 2;

    const newRipple = { 
      id: Date.now(),
      x: event.clientX - rect.left - radius,
      y: event.clientY - rect.top - radius,
      size: diameter,
    };

    setRipples([...ripples, newRipple]);
    
    // Auto-remove ripple after animation
    setTimeout(() => {
      setRipples(prev => prev.filter(r => r.id !== newRipple.id));
    }, 600);
  };
  
  return (
    <Link to={routes.CONTACTUS}>
      <button
        ref={buttonRef}
        type="button"
        className="px-6 py-3 bg-[#FFC067] text-dark font-bold text-base md:text-lg rounded shadow transition ease-in duration-300 button--two min-w-max overflow-hidden relative hover:bg-opacity-90"
        onClick={rippleEffect}
        title="Contact Apptalyst Team"
      >
        {ripples.map(ripple => (
          <span
            key={ripple.id}
            className="ripple"
            style={{
              width: `${ripple.size}px`,
              height: `${ripple.size}px`,
              left: `${ripple.x}px`,
              top: `${ripple.y}px`,
            }}
          />
        ))}
        Get Started
      </button>
    </Link>
  );
};

export default RippleButton;